(function() {
    'use strict';

    angular.module('dependencies-shared-components-module', [
        'ib-sticky-module',
        'ib-header-collapse-module',
        'ib-header-popover-module'
    ]);
})();